import React from "react"

class eBookBox extends React.Component {
  render() {
    const title = this.props.title
    const text = this.props.text
    const link = this.props.ebookDownload
    const CTA = this.props.textCTA
    return (
      <div className="media-content">
        <div className="content">
          <h2>{title}</h2>
          <p>{text}</p>
          <p className="has-text-centered">
            <a href={link} rel="noopener noreferrer" className="button is-primary is-rounded">
              {CTA}
            </a>
          </p>
        </div>
      </div>
    )
  }
}

export default eBookBox
